import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ControlsChildBaseComponent} from '../base/controls-child-base.component';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../app/app.state';
import {AsideService} from '../../../../core/services/aside.service';
import {UrlService} from '../../../../core/services/url.service';
import {TitleBreadcrumbsChangedAction, TitleChangedAction} from '../../../../core/actions/title.actions';
import {SubnavComponent, SubnavItem} from '../../../components/subnav/subnav.component';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-controls-tiles',
  templateUrl: './controls-tiles.component.html',
  styleUrls: ['./controls-tiles.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SubnavComponent,
    RouterOutlet,
  ],
})
export class ControlsTilesComponent extends ControlsChildBaseComponent implements OnInit, OnDestroy {
  subnavItems: SubnavItem[];


  constructor(
    protected store: Store<AppState>,
    protected asideService: AsideService,
    protected urlService: UrlService,
  ) {
    super(store, asideService, urlService);

    this.subnavItems = [
      {
        text: 'My Tiles',
        href: UrlService.controlsUrls.tilesExisting,
      },
      {
        text: 'Add Tiles',
        href: UrlService.controlsUrls.tilesNew,
      },
    ];
  }


  protected onInit(): void {
  }


  protected onDestroy(): void {
  }


  protected updateTitle() {
    this.store.dispatch(new TitleChangedAction(
      '',
      'Tiles',
      [{
        text: 'Loading...',
      }],
    ));

    this.store.dispatch(new TitleBreadcrumbsChangedAction(
      [{
        path: UrlService.controlsUrls.dashboard,
        text: 'Controls',
      }, {
        text: 'Tiles',
        icon: 'square-t',
      }],
    ));
  }
}
